import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FooterModal from "../common/FooterModal";
import Button from "../common/Button";
import ReactSlider from "react-slider";

const FilterModal = ({
  show,
  min = 0,
  max = 999,
  onClose,
  onSearch,
  onClear,
  seniorLayout = false,
}) => {
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState([min, max]);

  useEffect(() => {
    setCurrentValue([min, max]);
  }, [min, max, show]);

  const handleChange = (val) => setCurrentValue(val);

  return (
    <FooterModal show={show} onClose={onClose}>
      <div className="w-full flex flex-col items-center gap-y-7 px-10 xs:px-6 pt-7 pb-10">
        <div className="w-full border-b border-b-secondary-border text-3xl font-semibold pb-2">
          {t("search_filter")}
        </div>

        <div className="w-full flex flex-col gap-y-2">
          <div
            className={`font-semibold ${seniorLayout ? "text-2xl" : "text-22"}`}
          >
            {t("point_range")}
          </div>

          <div className="w-full h-24 px-3 py-10 relative">
            <ReactSlider
              className="w-full h-3"
              thumbClassName="w-6 h-6 bg-primary rounded-full cursor-pointer -mt-1"
              value={currentValue}
              min={min}
              max={max}
              onChange={handleChange}
              withTracks={true}
              pearling
              minDistance={1}
              renderTrack={(props, state) => {
                const index = props.key?.split("-").pop(); // "track-0", "track-1", etc.
                const color = index === "1" ? "bg-green-500" : "bg-gray-200"; // middle = green
                return (
                  <div
                    {...props}
                    className={`${color} h-3 rounded-full absolute`}
                    style={{ ...props.style }}
                  />
                );
              }}
              renderThumb={(props, state) => (
                <div {...props}>
                  <div className="absolute -top-8 left-1/2 -translate-x-1/2 text-sm bg-gray-100 px-2 py-1 rounded-full shadow">
                    {state.valueNow}
                  </div>
                </div>
              )}
            />
          </div>
        </div>

        <div className="w-full flex justify-center gap-3 xs:gap-1 whitespace-nowrap">
          <Button
            className="w-full h-11 flex-shrink text-lg font-medium"
            type="default"
            shape="round"
            onClick={onClear}
          >
            {t("clear_result")}
          </Button>
          <Button
            className="w-full h-11 flex-shrink text-lg font-medium"
            type="primary"
            shape="round"
            onClick={() => onSearch(currentValue)}
          >
            {t("show_result")}
          </Button>
        </div>
      </div>
    </FooterModal>
  );
};

export default FilterModal;
